import { Flex, Input, InputNumber } from "antd";
const { TextArea } = Input;

const CustomForm = ({ formColumn, selectedData, onDataChange }) => {
  // console.log(dataForm[2].length);
  const handleChange = (key, value) => {
    onDataChange(key, value); // Call the parent handler to update selectedData
  };

  return (
    <>
      <Flex vertical gap={12}>
        {formColumn?.map((e, i) =>
          // JIKA ITEM FORM ARRAY
          Array.isArray(e) === true ? (
            <div className={`grid grid-cols-${e && e.length} gap-4`} key={i}>
              {e.map((item, index) => (
                <div key={index}>
                  <label>{item.label} :</label>

                  {item.type === "text" && (
                    <Input
                      placeholder={item.placeholder}
                      defaultValue={selectedData ? selectedData[item.key] : ""}
                      // value={selectedData ? selectedData[item.key] : ""}
                      size="large"
                      className="mt-1"
                    />
                  )}

                  {item.type === "number" && (
                    <>
                      <br />
                      <InputNumber
                        min={1}
                        placeholder={item.placeholder}
                        value={selectedData ? selectedData[item.key] : ""}
                        size="large"
                        className="mt-1 w-full"
                      />
                    </>
                  )}

                  {item.type === "textarea" && (
                    <TextArea
                      rows={3}
                      placeholder={item.placeholder}
                      value={selectedData ? selectedData[item.key] : ""}
                      size="large"
                      className="mt-1"
                    />
                  )}
                </div>
              ))}
            </div>
          ) : (
            // JIKA ITEM FORM BUKAN ARRAY
            <div key={i}>
              <label>{e.label} :</label>

              {e.type === "text" && (
                <Input
                  placeholder={e.placeholder}
                  value={selectedData[e.key] || ""}
                  onChange={(event) => handleChange(e.key, event.target.value)}
                  size="large"
                  className="mt-1"
                />
              )}

              {e.type === "number" && (
                <>
                  <br />
                  <InputNumber
                    min={1}
                    placeholder={e.placeholder}
                    value={selectedData[e.key] || ""}
                    onChange={(value) => handleChange(e.key, value)}
                    size="large"
                    className="mt-1"
                  />
                </>
              )}

              {e.type === "textarea" && (
                <TextArea
                  rows={3}
                  placeholder={e.placeholder}
                  // value={selectedData ? selectedData[e.key] : ""}
                  onChange={(event) => handleChange(e.key, event.target.value)}
                  size="large"
                  className="mt-1"
                />
              )}
            </div>
          )
        )}
      </Flex>
    </>
  );
};

export default CustomForm;
